import { CHANNELS, DELIVERY_PLATFORMS } from './config';

const DELIVERY_CHANNEL_TRANSLATION_KEY = '_CHANNELS.DELIVERY';

export const extractChannels = (channelSale, defaultChannelId, clientChannels) => {
  if (Object.values(DELIVERY_PLATFORMS).includes(channelSale.mappedChannel)) {
    return CHANNELS.DELIVERY;
  }

  const deliveryChannel = clientChannels.find(
    ({ translationKey }) => translationKey === DELIVERY_CHANNEL_TRANSLATION_KEY,
  );

  return (
    channelSale.mappedChannel ||
    (!!deliveryChannel && defaultChannelId === deliveryChannel.id
      ? CHANNELS.DELIVERY
      : CHANNELS.DINE_IN)
  );
};

export const extractDeliveryPlatform = (channelSale) => {
  if (channelSale.analyticsChannel !== CHANNELS.DELIVERY) {
    return null;
  }
  if (channelSale.mappedChannel === 'delivery') {
    return DELIVERY_PLATFORMS.OTHER;
  }
  return channelSale.mappedChannel;
};
